import React from 'react';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { YOUTUBE_PREVIEW_SIZE } from 'client/utils/image-helpers';
import { VideoModuleUI } from 'site-modules/shared/components/video-module/video-module';

export function ArticleVideos({ entry, className, videoModuleProps, isMobile }) {
  const seeAllVideosLink = {
    href: entry.metadata('moreLink').value(),
    title: entry.metadata('moreLinkText').value(),
  };
  const videos = entry.children().map(child => child.getAllMetadata());

  return (
    <VideoModuleUI
      videos={videos}
      playlistTitle={entry.title}
      seeAllLink={seeAllVideosLink}
      className={className}
      {...videoModuleProps}
      isMobile={isMobile}
    />
  );
}

ArticleVideos.propTypes = {
  entry: CmsEntities.Content,
  className: PropTypes.string,
  videoModuleProps: PropTypes.shape({
    videoLargeColumnSize: PropTypes.number,
    playlistLargeColumnSize: PropTypes.number,
    playlistHasCurrentVideo: PropTypes.bool,
    isPlaylistSameHeight: PropTypes.bool,
    hideVideoDetails: PropTypes.bool,
    youtubeThumbnailSize: PropTypes.oneOf(Object.values(YOUTUBE_PREVIEW_SIZE)),
  }),
  isMobile: PropTypes.bool,
};

ArticleVideos.defaultProps = {
  entry: DEFAULT_CONTENT,
  className: 'mb-2 pb-1_5',
  videoModuleProps: {
    videoLargeColumnSize: 12,
    playlistLargeColumnSize: 12,
    playlistHasCurrentVideo: false,
    isPlaylistSameHeight: false,
    hideVideoDetails: true,
    youtubeThumbnailSize: YOUTUBE_PREVIEW_SIZE.MQ,
  },
  isMobile: false,
};
